<template>
    <div class="user-modal__forget">
        <div>
            <p class="headline-md">שכחת ססמה?</p>
            <span v-if="!clicked" class="user-modal__forget-text">
               הזן את הדוא"ל שלך
                <br>
                ואנחנו נשלח לך קישור לאיפוס הסיסמה שלך.
            </span>
          <span v-else class="user-modal__forget-text">
            <svg height="90" viewBox="0 0 24 24" width="90" xmlns="http://www.w3.org/2000/svg"><g id="Flat_Color" fill="#20bf55" data-name="Flat Color"><path d="m12 22.75a10.75 10.75 0 0 1 0-21.5 10.53 10.53 0 0 1 4.82 1.15.75.75 0 0 1 -.68 1.34 9 9 0 0 0 -4.14-1 9.25 9.25 0 1 0 9.25 9.26 2 2 0 0 0 0-.25.75.75 0 1 1 1.5-.14v.39a10.76 10.76 0 0 1 -10.75 10.75z"/><path d="m11.82 15.41a.7.7 0 0 1 -.52-.22l-4.83-4.74a.75.75 0 0 1 0-1.06.77.77 0 0 1 1.07 0l4.29 4.23 9.65-9.49a.77.77 0 0 1 1.07 0 .75.75 0 0 1 0 1.06l-10.18 10a.74.74 0 0 1 -.55.22z"/></g></svg>
          </span>
            <form action="#" @submit.prevent="forget" novalidate>
                <div class="floating-input-wrapper">
                    <input v-model="email"  type="text" name="email" class="floating-input" aria-label="דוא''ל" required>
                    <span v-bind:class="errors.email && errors.email[0] ? 'label-error floating-label' : 'floating-label'">
                    דוא''ל
                    <span class="required-star">*</span>
                    </span>
                </div>
                <div v-if="isSuccess">
                    asdf
                </div>
                <button type="submit" class="btn-black btn-client__forget-email" aria-label="שלח">
                    שלח
                </button>
                <div class="user-modal__links">
                    <a v-on:click="(event) => onClickButton(event, 'Login')">
                        בטל
                    </a>
                    <a :href="registerLink">
                        אין לך חשבון? הרשמה
                    </a>
                </div>
            </form>
        </div>
    </div>

</template>

<script>
    import axios from 'axios';

    export default {
        name: 'Forget',
        props: {
            modelValue: Object
        },
        computed: {
            registerLink() {
                return route('client.registration')
            },
        },
        data() {
            return {
                isSuccess: false,
                email: '',
                errors: [],
                clicked: false
            }
        },
        mounted() {
        },
        methods: {
            forget() {
                const that = this
                that.isSuccess = false
                axios.post('/customer-forget', {
                    email: this.email,
                })
                    .then((response) => {
                        that.isSuccess = true
                        that.email = ''
                    })
                    .catch((e) => {
                        //this.errors = e.response.data.errors;
                    })
                    that.clicked = true
              setTimeout(function () {
                $(".user-modal__close").click()
              }, 4000)
            },
            onClickButton(event, value) {
                this.$emit('clicked', value)
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
